/*
 * @Author: wangbaihe
 * @Date: 2023-10-24 15:08:17
 * @LastEditors: xiangliming
 * @LastEditTime: 2025-12-15 16:33:06
 * @FilePath: \common-mediax\src\apis\MediaCloudGateway\MediaCloudGateway.js
 * @Description:
 */
import { createAPI } from '@common'

export default {
  postLogin: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0f60mphjo', 'post', config),
  getAutologinChecksum: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0f60bvupmphjo0difdltvn', 'get', config),
  postLogout: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0f60mphpvu', 'post', config),
  getPortals: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0npet', 'get', config),
  getPortalsrr: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0npet', 'get', config, {
      neverLoading: true
    }),
  getMenus: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfs0qpsubmt', 'get', config),
  postMenus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfs0qpsubmt', 'post', config),
  // 获取验证码
  postLoginCaptcha: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0f60mphjo0dbqudib', 'get', config),
  // 获取web端租户配置信息（无token
  getTenantConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0xfc0fodszqujpo', 'get', config),
  // 获取web端租户配置信息中的图片（无token /mediax-resource/temporary/image
  getTemporaryImage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0ufnqpsbsz0jnbhf0cbtf75', 'get', config),
  // 修改个人字体偏好
  postMainUserPreference: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0qsfgfsfodf', 'post', config),
  // 获取个人字体偏好
  getMainUserPreference: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0qsfgfsfodf', 'get', config),
  // 获取二维码
  getMainUserQRCode: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0rsdpef', 'get', config),
  // 修改密码
  postLoginPassword: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0mphjo0qbttxpse', 'post', config),
  // 修改头像
  postMainUserIcon: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0jdpo', 'post', config),
  // 读系统版本号
  getDeplayVersion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0efqmpz0wfstjpo', 'get', config, {
      neverLoading: true
    }),
  // 登录密码校验
  postLoginValidation: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0mphjo0wbmjebujpo', 'post', config),
  // 未登录进去，修改密码
  postLoginPasswordFromLoginPage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0mphjo0qbttxpse', 'put', config),
  // 获取短信验证码
  postGetMessageVerifyCode: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0cjoe0dpef', 'post', config),
  // 绑定手机号
  postBindPhone: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0cjoe', 'post', config),
  // 修改密码-登录页判断密码过期，但是选择暂不修改密码，需要调接口更新过期时间
  putLoginPasswordDeadline: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0mphjo0qbttxpse0ebuf', 'put', config),
  // 密码+短信验证码双因子登陆
  postLoginBySmsAndPassword: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0tnt0mphjo', 'post', config),
  // 获取服务端公钥
  getPublicKey: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0qvclfz', 'get', config),
  postCheckPassword: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfs0difdlQbttxpse', 'post', config, vconfig),

  getParamsDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0qbsbnt0efubjm', 'get', config, vconfig),
  postAutoLogin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0f60bvupmphjo', 'post', config),
  postAutoLoginRemoteMediax: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0bvupmphjo', 'post', config),
  getLoginCheckSum: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0ttp0hfuMphjoDifdlTvn', 'get', config),
  // 暨南大学单点登录
  getCasLogin: (config) => createAPI('customEncryptApiName-1/0nfejby.pqfo0dbt0mphjo', 'get', config),
  // 触发登录路由判断跳到哪里
  getCasConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0dbt0dpogjh', 'get', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }),
  // 获取租户配置中的偏好信息
  getPreference: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ufobou0dpogjh0qsfgfsfodf', 'get', config),
  // 获取图片库系统参数配置
  getSysConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0tztDpogjh', 'get', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }),

  // 保存文件夹和用户的关联关系
  postUserfolderRemind: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0sfnjoe', 'POST', config),
  // 云端稿库自动登录（直接使用云雀域名做转发）
  autoLoginRR: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0dmpvefs0bvupmphjo', 'post', config),
  // 清空当前用户任务列表
  clearAsyncTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0btzodUbtl0dmfbs', 'post', config),
  // 删除单个任务
  deleteAsyncTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0btzodUbtl0efmfuf', 'post', config)
}
